import Description from "./description"
import Title from "./title"

const Address = ({
    text
}) => {
  const base = 'w-full flex flex-col items-center lg:items-start'

  return (
    <div className={base}>
      <Title text="Address" />
      <Description text={text} />
    </div>
  )
}

export default Address
